export default __webpack_public_path__ + "static/media/tabua-e-taca.c0d838b9.webp";